const CHUNK_ERROR_PATTERNS = [
    /failed to fetch dynamically imported module/i,
    /error loading dynamically imported module/i,
    /loading chunk [\d-]+ failed/i,
    /chunkloaderror/i,
    /importing a module script failed/i,
];

const RETRY_KEY_PREFIX = "qit:chunk-reload:";
const RETRY_WINDOW_MS = 60_000;

export const isChunkLoadError = (error: unknown): boolean => {
    const message = error instanceof Error ? `${error.name}: ${error.message}` : String(error ?? "");
    return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

export const getChunkRetryKey = (pathname: string): string =>
    `${RETRY_KEY_PREFIX}${pathname || "/"}`;

export const shouldRetryChunkLoad = (pathname: string, now = Date.now()): boolean => {
    if (typeof window === "undefined") return false;
    const key = getChunkRetryKey(pathname);
    try {
        const previousAttempt = Number(sessionStorage.getItem(key) || 0);
        if (Number.isFinite(previousAttempt) && now - previousAttempt < RETRY_WINDOW_MS) return false;
        sessionStorage.setItem(key, String(now));
        return true;
    } catch {
        return true;
    }
};

export const clearChunkLoadRetry = (pathname: string): void => {
    if (typeof window === "undefined") return;
    try {
        sessionStorage.removeItem(getChunkRetryKey(pathname));
    } catch {
        // Storage can be unavailable in privacy-restricted browsers.
    }
};
